export default "__VITE_ASSET__BVyldF4c__"